import { render, staticRenderFns } from "./pay_config_edit.vue?vue&type=template&id=8361fb86&scoped=true&"
import script from "./pay_config_edit.vue?vue&type=script&lang=ts&"
export * from "./pay_config_edit.vue?vue&type=script&lang=ts&"
import style0 from "./pay_config_edit.vue?vue&type=style&index=0&id=8361fb86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8361fb86",
  null
  
)

export default component.exports